import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedClientSelector($companyId: ID!, $id: ID) {
    clients(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        organisationName
        clientType { id name color }
      }
    }
  }
`

export const Query = gql`
  query ClientSelector(
    $companyId: ID!,
    $filters: ClientFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    clients(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        organisationName
        clientType { id name color }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
